"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFullWorkflowExportSections = void 0;
const workflowActionSection_1 = require("./workflowActionSection");
const formSection_1 = require("./formSection");
const debug_1 = require("debug");
// const debugLog = debug('reporting:info');
const verboseLog = (0, debug_1.default)('reporting:verbose');
const warnLog = (0, debug_1.default)('reporting:warning');
// const errorLog = debug('reporting:error');
/**
 * Generates a set of sections automatically based on a workflow schema.
 * @param {Object} workflowSchema The MongoDB object containing the schema for this workflow.
 * @param {GeneratorOptions=} options The options set in the export definition.
 *
 * @returns {SheetSchema[]} Returns an array of SheetSchemas
 */
function buildFullWorkflowExportSections(section, workflowSchema, schemas) {
    var _a, _b;
    if (workflowSchema == null)
        throw new Error(`Received null as workflowSchema. This means that workflow schema with ID ${section.workflow} was not found`);
    const { options } = section;
    // Grab all the actionTypes from the schema
    const actionTypes = Object.keys(((_a = workflowSchema === null || workflowSchema === void 0 ? void 0 : workflowSchema.schema) === null || _a === void 0 ? void 0 : _a.actions) || {}).filter((actionType) => { var _a; return !((_a = options === null || options === void 0 ? void 0 : options.excludedActions) === null || _a === void 0 ? void 0 : _a.includes(actionType)); });
    if (!actionTypes.length) {
        warnLog(`Workflow schema with ID ${workflowSchema._id.toString()} contained no actions`);
        return null;
    }
    // Iterate over the actionTypes. For each one, build a sheet.
    const sectionSchemas = [];
    actionTypes.forEach((actionType) => {
        const sectionSchema = (0, workflowActionSection_1.buildWorkflowActionSection)({
            action: actionType,
            options: options === null || options === void 0 ? void 0 : options.defaultSectionOptions,
            type: 'action',
            workflow: section.workflow,
        }, workflowSchema);
        if (sectionSchema) {
            (options === null || options === void 0 ? void 0 : options.verbose) &&
                verboseLog('... Generating schema for action ' + actionType);
            sectionSchemas.push(sectionSchema);
        }
        else {
            warnLog(`Generated a null sheet for action ${actionType}`);
        }
    });
    // Grab and add the external forms if specified
    if (section.externals) {
        const externalLabels = ((_b = workflowSchema === null || workflowSchema === void 0 ? void 0 : workflowSchema.schema) === null || _b === void 0 ? void 0 : _b.externals) || {};
        const externalIDs = workflowSchema.externals;
        for (const [label, type] of Object.entries(externalLabels)) {
            if (type === 'form') {
                const formId = externalIDs === null || externalIDs === void 0 ? void 0 : externalIDs[label];
                if (!formId)
                    throw new Error('Label missing from external IDs');
                const formSchema = schemas[formId.toString()];
                if (!formSchema)
                    throw new Error(`Formschema with ID ${formSchema} not found`);
                const sectionSchema = (0, formSection_1.buildFormSection)({
                    type: 'form',
                    form: formId,
                    options: options === null || options === void 0 ? void 0 : options.defaultSectionOptions,
                }, formSchema);
                sectionSchema && sectionSchemas.push(sectionSchema);
            }
        }
    }
    return sectionSchemas;
}
exports.buildFullWorkflowExportSections = buildFullWorkflowExportSections;
//# sourceMappingURL=fullWorkflowSection.js.map